// Resource: https://docs.oregonstate.education/api/#/content?id=delete-content-delete

import { mapState, mapGetters, mapActions } from "vuex";

const baseURL = "https://api.oregonstate.education/metrics/";
const ContentAPI = {
  computed: {
    ...mapState("env", ["publicKey"]),
    ...mapGetters(["getToken", "publicKey", "isDebugMode", "getSessionId"]),
    urlEntries() {
      return baseURL + "v1/events";
    },
    urlEntry() {
      return baseURL + "v1/event";
    },
    profileConfig() {
      const token = this.getToken;
      if (!token) {
        console.error("No token found");
        return {};
      }
      return {
        headers: { Authorization: `Bearer ${token}` }
      };
    },
    useCache() {
      return !this.isDebugMode;
    },
    page() {
      return "Sheet1";
    },
    id() {
      return process.env.VUE_APP_EVENTS_API_KEY;
    }
  },
  methods: {
    ...mapActions(["setAdminAnalytics"]),
    //  Read Content (GET)
    readContentEntries() {
      console.log("Attempting Reading Content Entries...");

      this.axios
        .get(this.urlEntries, {
          params: { id: this.id },
          ...this.profileConfig
        })
        .then((response) => {
          console.log(
            "Reading Content Entries Response",
            response.data.message
          );
          this.setAdminAnalytics(response.data.message);
        })
        .catch((error) => {
          console.error("Reading Error", error);
        })
        .finally(() => {
          console.log("Completing Reading Content Entries...");
        });
    },

    //  Create Content (POST)
    createContentEntry(payload, callback) {
      if (typeof payload !== "object" || payload === null) {
        console.error("Payload must be an object.");
        return;
      }

      payload.id = this.id;
      payload.session_id = this.getSessionId;
      // Make sure event_name is included in the payload
      if (!payload.event_name) {
        console.error("Payload is missing  event_name");
        return;
      }
      this.axios
        .post(this.urlEntry, payload, this.profileConfig)
        .then((response) => {
          console.log("Create Content Entry Response", response);
          // TODO:
        })
        .catch((error) => {
          console.error("Create Content Entry Error", error);
        })
        .finally(() => {
          console.log("Completing Update Content Entry...");
          if (callback) {
            callback();
          }
        });
    }
  }
};

export default ContentAPI;
